import { createFileRoute } from "@tanstack/react-router";
import { KeywordServiceLanding } from "@/components/KeywordServiceLanding";
import { keywordServiceHead } from "@/lib/keywordServicePages";
import { getTownMarketingPage } from "@/lib/townMarketingPages";

const PAGE = getTownMarketingPage("colorado-city");

export const Route = createFileRoute("/marketing-colorado-city")({
  head: () => keywordServiceHead(PAGE),
  component: () => <KeywordServiceLanding page={PAGE} />,
});
